module.exports = __webpack_public_path__ + "fonts/Nexa-Bold.30e9d5f.woff2";